export default __webpack_public_path__ + "static/media/CategoryExl.a1ab1548.xlsx";